"use client";
import Tooltip from "@stadium/ui/src/components/tooltip/tooltip";
import RadioInput from "@stadium/ui/src/components/form/RadioInput";
import Label from "@stadium/ui/src/components/form/Label";
import { MailToShop } from "@stadium/ui/src/components/mail-to";

// eslint-disable-next-line import/no-extraneous-dependencies
import { useCheckoutContext } from "@stadium/checkout/src/contexts/checkout";
// eslint-disable-next-line import/no-extraneous-dependencies
import { PAYMENT_METHODS } from "@stadium/checkout/src/constants/payment";

import styles from "./main.module.scss";

const TOOLTIP_CONTENT = (
  <div className={styles.coporateExtraInfo}>
    Available for enterprise accounts or orders $10,000+. Email <MailToShop /> for more info.
  </div>
);

const { corporateBilled } = PAYMENT_METHODS;

const CorporateBilling = ({
  orderTotal,
  isExistingOrder = false,
  showPaymentNote = false,
  className = "",
}) => {
  const {
    isCorporateBilledEnabled: isCorporateBilledEnabledFromContext,
    billingType,
    setBillingType,
    isPaymentPending,
  } = useCheckoutContext();

  const isCorporateBillingOptionSelected = billingType === corporateBilled.key;

  const isCorporateBilledEnabled =
    isCorporateBilledEnabledFromContext || (isCorporateBillingOptionSelected && isExistingOrder);

  const isDisabled =
    orderTotal <= 0 ||
    !isCorporateBilledEnabled ||
    (isExistingOrder && !isCorporateBillingOptionSelected) ||
    isPaymentPending;

  const onClick = () => {
    if (!isDisabled) {
      setBillingType(corporateBilled.key);
    }
  };

  if (!isCorporateBilledEnabled) return null;

  return (
    <div className={`${styles.cardContainer} ${className}`} onClick={onClick}>
      <RadioInput
        checked={isCorporateBillingOptionSelected}
        label={
          <Label
            iconType="radioOutline"
            showIcon={!isDisabled}
            styles={styles}
            className={styles.corporateLabel}
          >
            <div
              className={`${styles.corporateBillingSection}
                ${isDisabled ? "" : styles.enableSection}
              `}
            >
              Corporate Billing{" "}
              {!isCorporateBilledEnabled && (
                <>
                  <Tooltip
                    content={TOOLTIP_CONTENT}
                    isLightTheme
                    arrow
                    interactive
                    placement="top-start"
                    contentContainerClass={styles.tippyContent}
                  >
                    <span className={styles.billingInfoIcon} />
                  </Tooltip>
                  <span className={styles.billingInfo}>{TOOLTIP_CONTENT}</span>
                </>
              )}
            </div>
          </Label>
        }
      />
      <div className={`${styles.corporateBillingSubhead} ${!isDisabled && styles.withLeftPadding}`}>
        Corporate billing can’t be combined with other payment methods.
      </div>
      {isCorporateBilledEnabled && showPaymentNote && (
        <div
          className={`${styles.corporateBillingSubhead} ${!isDisabled && styles.withLeftPadding}`}
        >
          Invoices must be paid before products can go into production.
        </div>
      )}
    </div>
  );
};

export default CorporateBilling;
